import type { IconProps } from "./types";

export function FileIcon({
  size = 24,
  color = "currentColor",
  ...props
}: IconProps) {
  const currentColor =
    color === "currentColor"
      ? color
      : color.includes("#")
      ? color
      : `var(--${color})`;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.90039 0C10.0898 0 10.2651 0.0592002 10.4102 0.15918C10.4172 0.164042 10.4237 0.169733 10.4307 0.174805C10.4681 0.202199 10.5044 0.230956 10.5371 0.263672L15.5371 5.26367C15.5898 5.31636 15.6342 5.37556 15.6719 5.43848C15.7232 5.52393 15.7616 5.61798 15.7822 5.71875C15.7945 5.77809 15.8008 5.83892 15.8008 5.90039V17.1006C15.8007 17.8085 15.5272 18.4929 15.0332 19.001C14.5383 19.5099 13.8614 19.8008 13.1504 19.8008H2.65039C1.93934 19.8008 1.26245 19.5099 0.767578 19.001C0.273569 18.4929 5.05267e-05 17.8085 0 17.1006V2.7002C5.02202e-05 1.99223 0.273569 1.30793 0.767578 0.799805C1.26245 0.290883 1.93934 0 2.65039 0H9.90039ZM2.65039 1.80078C2.43341 1.80078 2.22004 1.88879 2.05859 2.05469C1.89631 2.2216 1.80083 2.45352 1.80078 2.7002V17.1006C1.80083 17.3473 1.89631 17.5792 2.05859 17.7461C2.22004 17.912 2.43341 18 2.65039 18H13.1504C13.3674 18 13.5807 17.912 13.7422 17.7461C13.9045 17.5792 13.9999 17.3473 14 17.1006V6.80078H9.90039C9.40333 6.80078 9 6.39745 9 5.90039V1.80078H2.65039ZM11.9004 13C12.3974 13 12.8008 13.4033 12.8008 13.9004C12.8008 14.3974 12.3974 14.8008 11.9004 14.8008H3.90039C3.40333 14.8008 3 14.3974 3 13.9004C3 13.4033 3.40333 13 3.90039 13H11.9004ZM11.9004 9.5C12.3974 9.5 12.8008 9.90333 12.8008 10.4004C12.8008 10.8974 12.3974 11.3008 11.9004 11.3008H3.90039C3.40333 11.3008 3 10.8974 3 10.4004C3 9.90333 3.40333 9.5 3.90039 9.5H11.9004ZM5.90039 6C6.39745 6 6.80078 6.40333 6.80078 6.90039C6.80078 7.39745 6.39745 7.80078 5.90039 7.80078H3.90039C3.40333 7.80078 3 7.39745 3 6.90039C3 6.40333 3.40333 6 3.90039 6H5.90039ZM10.8008 5H12.7266L10.8008 3.07422V5Z"
        fill={currentColor}
        transform="translate(4.1 2.1)"
      />
    </svg>
  );
}
